module.exports = __webpack_public_path__ + "images/category_lp/pc/SP_2_4902626bc822ebae2b44e35a2308496b.png";